import React from "react";
import { Alert, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const DocumentViewer = ({ documentUrl }) => {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const getFileExtension = (url) => {
    return url.split(".").pop().toLowerCase();
  };

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    setError("Impossible de charger le document");
  };

  const extension = getFileExtension(documentUrl);

  // Handle different file types appropriately
  if (["pdf"].includes(extension)) {
    return (
      <div className="document-viewer">
        {loading && (
          <div className="flex justify-center items-center h-64">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              tip="Chargement du document..."
            />
          </div>
        )}
        <iframe
          src={documentUrl}
          width="100%"
          height="500px"
          title="Document Viewer"
          onLoad={handleLoad}
          onError={handleError}
          style={{ display: loading ? "none" : "block" }}
        />
        {error && <Alert message={error} type="error" showIcon />}
      </div>
    );
  } else if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
    return (
      <div className="document-viewer text-center">
        {loading && (
          <div className="flex justify-center items-center h-64">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              tip="Chargement de l'image..."
            />
          </div>
        )}
        <img
          src={documentUrl}
          alt="Document"
          className="max-w-full max-h-[500px]"
          onLoad={handleLoad}
          onError={handleError}
          style={{ display: loading ? "none" : "block" }}
        />
        {error && <Alert message={error} type="error" showIcon />}
      </div>
    );
  }

  return (
    <Alert
      message="Type de document non supporté"
      description="Ce type de fichier ne peut pas être prévisualisé. Veuillez télécharger le document pour le visualiser."
      type="info"
      showIcon
    />
  );
};

export default DocumentViewer;
